module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-43.ae44f676.png";